import React from "react";
import { connect } from "react-redux";
import { Modal, Button } from "react-bootstrap";
import glamorous from "glamorous";

import Colors from "../../styles/colors";
import { FlexDiv } from "../../styles/container-elements";
import SavedSearchState from "../shipment-search/SavedSearchState";

class DeleteSearcModal extends React.Component {
  render() {
    const { show, hide, selectedSavedSearch, deleteSearch } = this.props;

    return (
      <Modal show={show} onHide={() => hide()}>
        <Modal.Header
          closeButton
          style={{
            padding: "0.5em",
            color: Colors.background.DARK_BLUE,
            backgroundColor: Colors.background.LIGHT_GRAY
          }}
        >
          <Modal.Title style={{ fontWeight: "300" }}>Delete Search</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ backgroundColor: Colors.background.LIGHT_GRAY }}>
          <glamorous.P css={{ fontWeight: "bold" }}>
            {selectedSavedSearch.name}
          </glamorous.P>
          <FlexDiv>
            Are you sure you would like to delete this saved search? This cannot
            be undone.
          </FlexDiv>
        </Modal.Body>
        <Modal.Footer style={{ backgroundColor: "#e2e2e2" }}>
          <Button
            style={{
              backgroundColor: "white",
              color: Colors.background.DARK_BLUE,
              marginRight: "0.5em"
            }}
            onClick={() => hide()}
          >
            Cancel
          </Button>
          <Button
            style={{
              backgroundColor: Colors.highlight.RED,
              color: "white",
              fontWeight: "300"
            }}
            onClick={() => {
              deleteSearch(selectedSavedSearch.id);
              hide();
            }}
          >
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    ...state.profile
  };
}

function mapDispatchToProps(dispatch) {
  return {
    deleteSearch: id =>
      dispatch(SavedSearchState.actionCreators.deleteSearch(id))
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeleteSearcModal);



// WEBPACK FOOTER //
// ./src/modules/profile/DeleteSearchModal.js